// Build-time flags: Expo inlines EXPO_PUBLIC_* values when bundling, so keep
// the direct `process.env.EXPO_PUBLIC_…` references.

// Download everything (Profile › Download everything): every recording of a
// business account with its own download link, plus the account's data files.
// Off unless a build sets EXPO_PUBLIC_DOWNLOAD_EVERYTHING to "true" (the web
// reads it from the Netlify build env, the apps from the EAS build env).
export const DOWNLOAD_EVERYTHING_ENABLED =
  process.env.EXPO_PUBLIC_DOWNLOAD_EVERYTHING === "true";

// evt.live serves the list, the MP4 downloads and the data files
// (/api/library/*). A deploy preview can point at a preview of evt.live.
export const LIBRARY_API_URL = (
  process.env.EXPO_PUBLIC_LIBRARY_API_URL || "https://evt.live"
).replace(/\/+$/, "");

// Who sees it: business accounts, while the flag is on.
export const libraryAvailableFor = (accountType) =>
  DOWNLOAD_EVERYTHING_ENABLED && accountType === "business";
